import React, { useState, useEffect } from "react";
import { Navbar, Container, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { citationsAPI } from "../services/supabaseClient";

import "./Navbar.css";

const MyNavbar = (props) => {
  // Removed: const [secondLine, setSecondLine] = useState("");

  const [citat, setCitat] = useState({
    "biblicky-citat-text": "",
    "biblicky-citat-citace": "",
  });

  useEffect(() => {
    const fetchCitation = async () => {
      try {
        const data = await citationsAPI.getRandom();
        setCitat({
          "biblicky-citat-text": data.citatdne,
          "biblicky-citat-citace": data.citatautor,
        });
      } catch (error) {
        console.error("Error fetching citation:", error);
      }
    };
    fetchCitation();
  }, []);

  return (
    <Navbar
      className={`navbar ${props.isMeditationMode ? "navbar-meditation" : ""}`}
      bg="bg-moje"
      expand="lg"
      fixed="top"
    >
      <Container>
        <Navbar.Brand href="#" onClick={props.onHome}>
          <div className="logo-wrapper">
            <div className="navbar-dove">
              <i className="fas fa-dove"></i>
            </div>
            <div className="navbar-tone">
              <i className="fas fa-music"></i>
            </div>
          </div>
          <div className="text">Zvuky Víry</div>
          <div className="text"></div>
        </Navbar.Brand>

        <Navbar.Text className="navbar-text">
          {!props.isCatalogVisible && !props.isMeditationMode && (
            <Button
              className="btn-moje btn-navbar"
              onClick={props.onShowCatalog}
            >
              <span className="btn-navbar-text">Katalog interpretů</span>
              <i className="fa-solid fa-list btn-navbar-icon"></i>
            </Button>
          )}
        </Navbar.Text>

        {!props.isMeditationMode && (
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 2, delay: 1 }}
            className="navbar-text navbar-citat-wrapper"
            style={{ width: "40%" }}
          >
            <a
              href="https://www.vira.cz/"
              target="_blank"
              rel="noreferrer"
              aria-label="Citát dne z webu Vira.cz"
            >
              <div className="citat-text">{citat["biblicky-citat-text"]}</div>
              <div className="citat-autor">{citat["biblicky-citat-citace"]}</div>
            </a>
          </motion.div>
        )}
      </Container>
    </Navbar>
  );
};

export default MyNavbar;
